/* ============================================================
   MOSSEN — Menu du bouton Profil
   Se greffe sur l'icône compte du header et ouvre un menu.
   Le menu est monté dans <body> : il échappe aux conteneurs
   en overflow du header, qui le rogneraient sinon.
   ============================================================ */
(function () {
  'use strict';

  var ITEMS = [
    { label: 'Se connecter',       href: '/pages/mon-compte' },
    { label: 'Assistance',         href: '/pages/assistance' },
    { label: 'Suivre ma commande', href: '/pages/suivi' },
    { label: 'Mes favoris',        href: '/pages/mes-favoris', muted: true }
  ];

  /* ---------- Styles ---------- */
  function injectStyles() {
    if (document.getElementById('mossen-account-styles')) return;
    var s = document.createElement('style');
    s.id = 'mossen-account-styles';
    s.textContent = [
      '.mossen-account-menu{',
      '  position:fixed; z-index:2147483647; min-width:216px;',
      '  inset:auto; margin:0; overflow:visible;',
      '  background:#fff; border:1px solid #e5e5e5; border-radius:14px;',
      '  box-shadow:0 12px 34px rgba(17,17,17,.14);',
      '  padding:8px; opacity:0; transform:translateY(-6px);',
      '  transition:opacity .18s ease, transform .18s ease;',
      '}',
      '.mossen-account-menu:popover-open{inset:auto; margin:0;}',
      '.mossen-account-menu.is-open{opacity:1; transform:translateY(0);}',
      '.mossen-account-menu a{',
      '  display:block; padding:11px 14px; border-radius:9px;',
      '  font-size:13px; line-height:1.3; letter-spacing:-.01em;',
      '  color:#111; text-decoration:none; white-space:nowrap;',
      '  transition:background .15s ease;',
      '}',
      '.mossen-account-menu a:hover,',
      '.mossen-account-menu a:focus{background:#f4f4f4; outline:none;}',
      '.mossen-account-menu a.is-muted{color:#6e6e73;}',
      '.mossen-account-menu hr{',
      '  border:0; border-top:1px solid #ededed; margin:8px 6px;',
      '}',
      '#mossen-account-veil{position:fixed; inset:0; z-index:2147483646; background:transparent;}',
      '@media (max-width:749px){',
      '  .mossen-account-menu{min-width:0; left:12px !important; right:12px !important; border-radius:16px;}',
      '  .mossen-account-menu a{padding:13px 14px; font-size:14px;}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- Repérage du bouton compte ---------- */
  function findAccountButton() {
    // Par ordre de fiabilité : la classe du thème, puis le libellé,
    // puis les destinations habituelles
    var selectors = [
      '.account-btn',
      '[aria-label="Mon compte"]',
      'a[href*="/pages/mon-compte"]',
      'a[href$="/account"]',
      'a[href*="/account/login"]',
      '.header__icon--account'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var found = [].slice.call(document.querySelectorAll(selectors[i])).filter(function (el) {
        if (el.closest('#mossen-account-menu')) return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      });
      if (found.length) return found[0];
    }
    return null;
  }

  /* ---------- Menu ---------- */
  var menu = null, veil = null, anchor = null;

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    var m = menu, v = veil;
    menu = null; veil = null;
    setTimeout(function () {
      if (m) {
        if (m.hidePopover && m.hasAttribute('popover')) {
          try { m.hidePopover(); } catch (err) { /* déjà fermé */ }
        }
        if (m.parentNode) m.parentNode.removeChild(m);
      }
      if (v && v.parentNode) v.parentNode.removeChild(v);
    }, 180);
    window.removeEventListener('resize', closeMenu);
    window.removeEventListener('scroll', closeMenu, true);
    if (anchor) anchor.setAttribute('aria-expanded', 'false');
  }

  function place() {
    if (!menu || !anchor) return;
    var r = anchor.getBoundingClientRect();
    var w = menu.offsetWidth;
    var margin = 12;
    var left = r.right - w;                      // aligné sur le bord droit de l'icône
    if (left + w > window.innerWidth - margin) left = window.innerWidth - w - margin;
    if (left < margin) left = margin;
    menu.style.top = Math.round(r.bottom + 10) + 'px';
    menu.style.left = Math.round(left) + 'px';
  }

  function openMenu(btn) {
    anchor = btn;

    veil = document.createElement('div');
    veil.id = 'mossen-account-veil';
    veil.addEventListener('click', closeMenu);
    document.body.appendChild(veil);

    menu = document.createElement('div');
    menu.id = 'mossen-account-menu';
    menu.className = 'mossen-account-menu';
    menu.setAttribute('role', 'menu');
    menu.innerHTML = ITEMS.map(function (it, i) {
      var sep = (i === ITEMS.length - 1) ? '<hr>' : '';
      return sep + '<a role="menuitem" href="' + it.href + '"' +
             (it.muted ? ' class="is-muted"' : '') + '>' + it.label + '</a>';
    }).join('');
    menu.addEventListener('click', function (e) { e.stopPropagation(); });

    // Top layer : le menu passe devant le header quel que soit son z-index
    var canPopover = typeof menu.showPopover === 'function';
    if (canPopover) menu.setAttribute('popover', 'manual');
    document.body.appendChild(menu);
    if (canPopover) {
      try { menu.showPopover(); } catch (err) { /* repli sur le z-index */ }
    }

    place();
    requestAnimationFrame(function () { menu.classList.add('is-open'); });

    var first = menu.querySelector('a');
    if (first) first.focus();

    btn.setAttribute('aria-expanded', 'true');
    window.addEventListener('resize', closeMenu);
    window.addEventListener('scroll', closeMenu, true);
  }

  /* ---------- Branchement ---------- */
  function bind() {
    var btn = findAccountButton();
    if (!btn) { setTimeout(bind, 400); return; }
    if (btn.dataset.mossenBound) return;

    btn.dataset.mossenBound = '1';
    btn.setAttribute('aria-haspopup', 'menu');
    btn.setAttribute('aria-expanded', 'false');

    btn.addEventListener('click', function (e) {
      e.preventDefault();          // le lien reste valable si le script échoue
      e.stopPropagation();
      if (menu) closeMenu(); else openMenu(btn);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  injectStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(bind, 200); });
  } else {
    setTimeout(bind, 200);
  }
})();